import './component';
import './preview';

const { Application } = Shopware;

Application.getContainer('service').cmsService.registerCmsBlock({
    name: 'product-finder',
    label: 'sw-cms.blocks.commerce.productFinder.label',
    category: 'commerce',
    component: 'sw-cms-block-product-finder',
    previewComponent: 'sw-cms-preview-product-finder',
    defaultConfig: {
        marginBottom: '20px',
        marginTop: '20px',
        marginLeft: '20px',
        marginRight: '20px',
        sizingMode: 'boxed'
    },
    slots: {
        content: {
            type: 'product-finder',
            default: {
                config: {
                    productFinder: {
                        source: 'static',
                        value: null
                    }
                }
            }
        }
    }
});